import { render, staticRenderFns } from "./AddTOG.vue?vue&type=template&id=570debea&scoped=true"
import script from "./AddTOG.vue?vue&type=script&lang=js"
export * from "./AddTOG.vue?vue&type=script&lang=js"
import style0 from "./AddTOG.vue?vue&type=style&index=0&id=570debea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570debea",
  null
  
)

export default component.exports